<script setup lang="ts">
import { User } from '@auth0/auth0-vue'

import { Avatar, AvatarFallback, AvatarImage } from '@/ui'
import { cn } from '@/utils'

defineProps<{
  user?: User
  className?: string
}>()
</script>

<template>
  <Avatar :class="cn('border text-white', className)">
    <AvatarImage v-if="user" :src="user.picture || ''" alt="avatar" />
    <AvatarFallback>{{ user ? user.nickname : 'XX' }}</AvatarFallback>
  </Avatar>
  <div class="grid flex-1 text-left text-sm leading-tight">
    <span class="truncate font-semibold">{{ user ? user.name : 'Noname' }}</span>
    <span v-if="user && user.name !== user.email" class="truncate text-xs">{{ user.email }}</span>
  </div>
</template>
